<template>
  <div
    v-on:keyup.enter="submit"
    ref="monitoring"
    :class="isFullscreen ? 'monitoring-active' : 'monitoring'"
  >
    <div class="head">
      <div v-if="isFullscreen" style="position: absolute; top: 0.05rem; left: 0.1rem; width: 100%;">
        <div class="logo fl">
          <img src="../../assets/images/logo.png" width="28" height="23" alt="" />
        </div>
        <div style="color: #dddddd; font-size: 0.1rem;">广东海川机器人</div>
      </div>
      <div class="screen" @click="LargeScreen">
        {{ isFullscreen ? "退出" : "全屏" }}
      </div>
      <div class="title">美苏智能科技互联实时监控(二线)</div>
    </div>
    <!-- Form -->
    <el-dialog title="修改生产信息" :visible.sync="outerVisible">
      <el-form :model="form">
        <el-form-item label="制令单号" :label-width="formLabelWidth">
          <el-input v-model="form.code" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="零件名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="计划产量" :label-width="formLabelWidth">
          <el-input v-model="form.product" type="number" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <el-dialog
        width="30%"
        title="密码校验"
        :visible.sync="innerVisible"
        append-to-body>
        <el-form>
          <el-form-item label="修改信息需密码" :label-width="formLabelWidth">
            <el-input placeholder="请输入密码" v-model="form.password" show-password></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="submit">确 定</el-button>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outerVisible = false">取 消</el-button>
        <el-button type="primary" @click="editConfig">确 定</el-button>
      </div>
    </el-dialog>
    <div class="table">
      <el-row :gutter="10">
        <el-col :span="6">
          <div class="state">
            <h4 class="title-small" style="font-size: 0.2rem; position: relative;" >实时生产状态<el-button type="text" style="position: relative; z-index: 1000;" @click="outerVisible = true">可修改</el-button></h4>
              <div class="tableSate" style="font-size: 0.14rem;">
                <el-row>
                  <el-col :span="7" :offset="1"><div>制令单号：</div></el-col>
                  <el-col :span="16"><div class="orange">{{productInfoB.number}}</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" :offset="1"><div>零件名称：</div></el-col>
                  <el-col :span="16"><div class="orange">{{productInfoB.model}}</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" :offset="1"><div>计划产量：</div></el-col>
                  <el-col :span="16"><div class="orange">{{productInfoB.output}}</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" :offset="1"><div>当前产量：</div></el-col>
                  <el-col :span="16"><div class="orange">{{productInfoB.doneProduct}}</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" :offset="1"><div>剩余产量：</div></el-col>
                  <el-col :span="16"><div class="orange">{{productInfoB.product}}</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" :offset="1"><div>当前产能：</div></el-col>
                  <el-col :span="16"><div class="orange">{{productInfoB.products}}/分</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" :offset="1"><div>预计完成：</div></el-col>
                  <el-col :span="16"><div class="orange">{{productInfoB.doneTime}} 分钟</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" :offset="1"><div>当前进度：</div></el-col>
                  <el-col :span="12">
                    <div style="padding-top: 3px;">
                      <el-progress :percentage="productInfoB.progress" color="green" :stroke-width="22" :show-text="false"></el-progress>
                    </div>
                  </el-col>
                  <el-col :span="3" :offset="1"><div class="rote orange">{{productInfoB.progress}}%</div></el-col>
                </el-row>
              </div>
<!--            <div class="echarts1" ref="echarts1"></div>-->

<!--            <ve-heatmap-->
<!--              :data="chartData"-->
<!--              :x-axis="faultyxAxis"-->
<!--              :y-axis="faultyAxis1"-->
<!--            ></ve-heatmap>-->
          </div>
        </el-col>
        <el-col :span="12">
          <div class="middle">
            <img
              class="img-scale"
              src="../../assets/images/assembly.png"
              alt=""
            />
          </div>
        </el-col>
        <el-col :span="6">
          <div class="state">
            <h4 class="title-small" style="font-size: 0.2rem;">运作状态</h4>
<!--            <ve-bar :data="faultData" :x-axis="xAxis" :y-axis="yAxis1"></ve-bar>-->
              <div class="tableSate">
                <el-row>
                  <el-col :span="8"><div class="td th">设备名</div></el-col>
                  <el-col :span="8"><div class="td th">状态</div></el-col>
                  <el-col :span="8"><div class="td th">异常时间</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="2">
                    <div class="td" style="height: 0.4rem; line-height: 0.18rem;">送<br>料</div>
                  </el-col>
                  <el-col :span="6">
                    <div class="td" style="height: 0.4rem; line-height: 0.4rem;" v-for="fee in driveObj.driveB.feeder">{{fee.title}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" :class="fee.color" style="height: 0.4rem; line-height: 0.4rem;" v-for="fee in driveObj.driveB.feeder">{{fee.status}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" style="height: 0.4rem; line-height: 0.4rem;" v-for="fee in driveObj.driveB.feeder">{{fee.time}}</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="2">
                    <div class="td" style="line-height: 0.24rem; height: 0.52rem;">拉<br>伸</div>
                  </el-col>
                  <el-col :span="6">
                    <div class="td" v-for="car in driveObj.driveB.handcar">{{car.title}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" :class="car.color" v-for="car in driveObj.driveB.handcar">{{car.status}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" v-for="car in driveObj.driveB.handcar">{{car.time}}</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="2">
                    <div class="td" style="line-height: 0.24rem; height: 0.52rem;">冲<br>床</div>
                  </el-col>
                  <el-col :span="6">
                    <div class="td" v-for="pun in driveObj.driveB.punch">{{pun.title}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" :class="pun.color" v-for="pun in driveObj.driveB.punch">{{pun.status}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" v-for="pun in driveObj.driveB.punch">{{pun.time}}</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="2">
                    <div class="td" style="line-height: 0.25rem; height: 0.78rem;">机<br>器<br>人</div>
                  </el-col>
                  <el-col :span="6">
                    <div class="td" v-for="rob in driveObj.driveB.robot">{{rob.title}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" :class="rob.color" v-for="rob in driveObj.driveB.robot">{{rob.status}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" v-for="rob in driveObj.driveB.robot">{{rob.time}}</div>
                  </el-col>
                </el-row>
              </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 稼动率 -->
<!--    <div class="activation" :ref="activation">-->
<!--      <div class="efficency" ref="efficency"></div>-->
<!--    </div>-->
    <div class="table" style="max-height: 310px; overflow: hidden; margin-bottom: 50px;">
      <el-table
        ref="table"
        :data="statementB"
        border
        :stripe="true"
        style="width: 100%"
        :cell-style="tableRowStyle"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column :size="'medium'" prop="state" label="生产状态" width="180" >
        </el-table-column>
        <el-table-column prop="date" label="日期" width="180">
        </el-table-column>
        <el-table-column prop="odd" label="制令单号" width="180">
        </el-table-column>
        <el-table-column prop="name" label="零件名称"> </el-table-column>
        <el-table-column prop="yield" label="计划产量"> </el-table-column>
<!--        <el-table-column prop="capacity" label="产能"> </el-table-column>-->
<!--        <el-table-column prop="predict" label="预计完成用时"> </el-table-column>-->
<!--        <el-table-column prop="present" label="当前完成数量"> </el-table-column>-->
<!--        <el-table-column prop="schedule" label="进度"> </el-table-column>-->
      </el-table>
    </div>
  </div>
</template>
<script>
// // 引入vueX数据管理中心
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState } = createNamespacedHelpers("menuModule");

import FileSaver from "file-saver";
import XLSX from "xlsx";
// import screenfull from "screenfull";
// import echarts from 'echarts'
export default {
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    next((vm) => {
      if (from.name == null) {
        vm.isFullscreen = true;
      }
    });
  },
  data() {
    return {
      Timer: null,
      isFullscreen: false, // 是否全屏
      outerVisible: false,
      innerVisible: false,
      form: {
          name: '',
          code: '',
          product: '',
          password:'',
      },
      formLabelWidth: '120px',

      // 表格
      statementB: [
        {
            state:'--', // 计划生产状态
            date:'--', // 计划生产日期
            odd:'--', // 计划生产制令
            name:'--', // 计划生产零件名称
            yield:'--', // 计划生产产量
        },{
            state:'--', // 计划生产状态
            date:'--', // 计划生产日期
            odd:'--', // 计划生产制令
            name:'--', // 计划生产零件名称
            yield:'--', // 计划生产产量
        },{
            state:'--', // 计划生产状态
            date:'--', // 计划生产日期
            odd:'--', // 计划生产制令
            name:'--', // 计划生产零件名称
            yield:'--', // 计划生产产量
        },{
            state:'--', // 计划生产状态
            date:'--', // 计划生产日期
            odd:'--', // 计划生产制令
            name:'--', // 计划生产零件名称
            yield:'--', // 计划生产产量
        },{
            state:'--', // 计划生产状态
            date:'--', // 计划生产日期
            odd:'--', // 计划生产制令
            name:'--', // 计划生产零件名称
            yield:'--', // 计划生产产量
        },{
            state:'--', // 计划生产状态
            date:'--', // 计划生产日期
            odd:'--', // 计划生产制令
            name:'--', // 计划生产零件名称
            yield:'--', // 计划生产产量
        }
      ],


      // productList:[ // 近日表格列表
      //   {
      //     created_at: "2020-12-07 02:03:22",
      //     deleted_at: null,
      //     end: "2020-12-18",
      //     id: 3,
      //     line: "A线",
      //     model: "D02锅体",
      //     numbers: "152115",
      //     output: 100000,
      //     start: "2020-12-07",
      //     status: "已完成",
      //     updated_at: "2020-12-07 02:03:22",
      //   }, {
      //     created_at: "2020-12-07 02:20:35",
      //     deleted_at: null,
      //     end: "2020-12-18",
      //     id: 4,
      //     line: "A线",
      //     model: "F08锅体",
      //     numbers: "60000",
      //     output: 80000,
      //     start: "2020-12-07",
      //     status: "计划未实施",
      //     updated_at: "2020-12-07 02:20:35",
      //   }
      // ],




      // // 初始设备对象
      // devices: {}, // 所有设备对象集
      // // 状态
      // status: {  // 状态
      //   product: '生产',
      //   producting: '生产中',
      //   productWait: '待生产',
      //   productReady: '准备生产',
      //   productDone: '生产完成',
      //   productError: '异常停机',
      //   productStop: '急停',
      //   changeModel: '换模',
      //   changeingModel: '换模中',
      //   auto: '自动',
      //   hand: '手动',
      //   run: '运行',
      //   alarm: '故障',
      //   stop: '停机',
      //   wait: '待机',
      //   waiting: '等待',
      //   warning: '报警',
      //   normal: '正常',
      //   clone: '关闭',
      //   off: '关机',
      //   on: '开机',
      //   start: '开始',
      //   error: '异常',
      //   done: '完成',
      //   runStop: '停止',
      //   runByIn: '就绪',
      // },

      // // 稼动率
      // efficency: null, // dom对象
      // // 状态
      // echarts1: null, // dom对象


      // testWarning: [],
      // // 稼动率
      // activation: {
      //   title: [
      //     {
      //       text: "1#机器人稼动率",
      //       left: "5%",
      //       top: "82%",
      //       textAlign: "center",
      //       textStyle: {
      //         fontWeight: "normal",
      //         fontSize: "16",
      //         color: "#FFF",
      //         textAlign: "center",
      //       },
      //     },
      //     {
      //       text: "2#机器人稼动率",
      //       left: "15%",
      //       top: "82%",
      //       textAlign: "center",
      //       textStyle: {
      //         fontWeight: "normal",
      //         fontSize: "16",
      //         color: "#FFF",
      //         textAlign: "center",
      //       },
      //     },
      //     {
      //       text: "3#机器人稼动率",
      //       left: "25%",
      //       top: "82%",
      //       textAlign: "center",
      //       textStyle: {
      //         fontWeight: "normal",
      //         fontSize: "16",
      //         color: "#FFF",
      //         textAlign: "center",
      //       },
      //     },
      //
      //     {
      //       text: "切边冲床稼动率",
      //       left: "35%",
      //       top: "82%",
      //       textAlign: "center",
      //       textStyle: {
      //         fontWeight: "normal",
      //         fontSize: "16",
      //         color: "#FFF",
      //         textAlign: "center",
      //       },
      //     },
      //     {
      //       text: "翻边冲床稼动率",
      //       left: "45%",
      //       top: "82%",
      //       textAlign: "center",
      //       textStyle: {
      //         fontWeight: "normal",
      //         fontSize: "16",
      //         color: "#FFF",
      //         textAlign: "center",
      //       },
      //     },
      //     {
      //       text: "切片上料机稼动率",
      //       left: "55%",
      //       top: "82%",
      //       textAlign: "center",
      //       textStyle: {
      //         fontWeight: "normal",
      //         fontSize: "16",
      //         color: "#FFF",
      //         textAlign: "center",
      //       },
      //     },
      //     {
      //       text: "生产进度",
      //       left: "70%",
      //       top: "82%",
      //       textAlign: "center",
      //       textStyle: {
      //         fontWeight: "normal",
      //         fontSize: "16",
      //         color: "#FFF",
      //         textAlign: "center",
      //       },
      //     },
      //
      //     {
      //       text: "停机持续时间:",
      //       left: "82%",
      //       top: "45%",
      //       textAlign: "center",
      //       textStyle: {
      //         fontWeight: "normal",
      //         fontSize: "24",
      //         color: "#ffb8db",
      //         textAlign: "center",
      //       },
      //     },
      //
      //     {
      //       text: "00:00:00",
      //       left: "90%",
      //       top: "46%",
      //       textAlign: "center",
      //       textStyle: {
      //         fontWeight: "normal",
      //         fontSize: "22",
      //         color: "#FFF",
      //         textAlign: "center",
      //       },
      //     },
      //   ],
      //   series: [
      //     {
      //       name: "1#机器人稼动率",
      //       type: "pie",
      //       startAngle: 180,
      //       center: ["5%", "44%"],
      //       clockWise: false,
      //       radius: [50, 56],
      //       itemStyle: {
      //         color: "#8cc265",
      //         shadowColor: "#8cc265",
      //         shadowBlur: 0,
      //         label: null,
      //         labelLine: null,
      //         borderWidth: 1,
      //       },
      //       hoverAnimation: false,
      //
      //       data: [
      //         {
      //           value: 0,
      //           name: "0%",
      //           label: {
      //             position: "center",
      //             show: true,
      //             textStyle: {
      //               fontSize: "30",
      //               fontWeight: "bold",
      //               color: "#8cc265",
      //             },
      //           },
      //         },
      //         {
      //           value: 100,
      //           name: "目标稼动率",
      //           itemStyle: {
      //             color: "#f4f4f7",
      //           },
      //           emphasis: {
      //             itemStyle: {
      //               color: "#f4f4f7",
      //             },
      //           },
      //         },
      //       ],
      //       label: {
      //         show: false,
      //       },
      //     },
      //     {
      //       name: "2#机器人稼动率",
      //       type: "pie",
      //       startAngle: 180,
      //       center: ["15%", "44%"],
      //       clockWise: false,
      //       radius: [50, 56],
      //       itemStyle: {
      //         color: "#b362e1",
      //         shadowColor: "#b362e1",
      //         shadowBlur: 0,
      //         label: null,
      //         labelLine: null,
      //         borderWidth: 1,
      //       },
      //       hoverAnimation: false,
      //
      //       data: [
      //         {
      //           value: 0,
      //           name: "0%",
      //           label: {
      //             position: "center",
      //             show: true,
      //             textStyle: {
      //               fontSize: "30",
      //               fontWeight: "bold",
      //               color: "#b362e1",
      //             },
      //           },
      //         },
      //         {
      //           value: 100,
      //           name: "目标稼动率",
      //           itemStyle: {
      //             color: "#f4f4f7",
      //           },
      //           emphasis: {
      //             itemStyle: {
      //               color: "#f4f4f7",
      //             },
      //           },
      //         },
      //       ],
      //       label: {
      //         show: false,
      //       },
      //     },
      //     {
      //       name: "3#机器人稼动率",
      //       type: "pie",
      //       startAngle: 180,
      //       center: ["25%", "44%"],
      //       clockWise: false,
      //       radius: [50, 56],
      //       itemStyle: {
      //         color: "#fb5531",
      //         shadowColor: "#fb5531",
      //         shadowBlur: 0,
      //         label: null,
      //         labelLine: null,
      //         borderWidth: 1,
      //       },
      //       hoverAnimation: false,
      //
      //       data: [
      //         {
      //           value: 0,
      //           name: "0%",
      //           label: {
      //             position: "center",
      //             show: true,
      //             textStyle: {
      //               fontSize: "30",
      //               fontWeight: "bold",
      //               color: "#fb5531",
      //             },
      //           },
      //         },
      //         {
      //           value: 100,
      //           name: "目标稼动率",
      //           itemStyle: {
      //             color: "#f4f4f7",
      //           },
      //           emphasis: {
      //             itemStyle: {
      //               color: "#f4f4f7",
      //             },
      //           },
      //         },
      //       ],
      //       label: {
      //         show: false,
      //       },
      //     },
      //
      //     {
      //       name: "切边冲床稼动率",
      //       type: "pie",
      //       startAngle: 180,
      //       center: ["35%", "44%"],
      //       clockWise: false,
      //       radius: [50, 56],
      //       itemStyle: {
      //         color: "#fdf101",
      //         shadowColor: "#fdf101",
      //         shadowBlur: 0,
      //         label: null,
      //         labelLine: null,
      //         borderWidth: 1,
      //       },
      //       hoverAnimation: false,
      //
      //       data: [
      //         {
      //           value: 0,
      //           name: "0%",
      //           label: {
      //             position: "center",
      //             show: true,
      //             textStyle: {
      //               fontSize: "30",
      //               fontWeight: "bold",
      //               color: "#fdf101",
      //             },
      //           },
      //         },
      //         {
      //           value: 100,
      //           name: "目标稼动率",
      //           itemStyle: {
      //             color: "#f4f4f7",
      //           },
      //           emphasis: {
      //             itemStyle: {
      //               color: "#f4f4f7",
      //             },
      //           },
      //         },
      //       ],
      //       label: {
      //         show: false,
      //       },
      //     },
      //
      //     {
      //       name: "翻边冲床稼动率",
      //       type: "pie",
      //       startAngle: 180,
      //       center: ["45%", "44%"],
      //       clockWise: false,
      //       radius: [50, 56],
      //       itemStyle: {
      //         color: "#ffb8db",
      //         shadowColor: "#ffb8db",
      //         shadowBlur: 0,
      //         label: null,
      //         labelLine: null,
      //         borderWidth: 1,
      //       },
      //       hoverAnimation: false,
      //
      //       data: [
      //         {
      //           value: 0,
      //           name: "0%",
      //           label: {
      //             position: "center",
      //             show: true,
      //             textStyle: {
      //               fontSize: "30",
      //               fontWeight: "bold",
      //               color: "#ffb8db",
      //             },
      //           },
      //         },
      //         {
      //           value: 100,
      //           name: "目标稼动率",
      //           itemStyle: {
      //             color: "#f4f4f7",
      //           },
      //           emphasis: {
      //             itemStyle: {
      //               color: "#f4f4f7",
      //             },
      //           },
      //         },
      //       ],
      //       label: {
      //         show: false,
      //       },
      //     },
      //     {
      //       name: "切片上料机稼动率",
      //       type: "pie",
      //       startAngle: 180,
      //       center: ["55%", "44%"],
      //       clockWise: false,
      //       radius: [50, 56],
      //       itemStyle: {
      //         color: "#ec191b",
      //         shadowColor: "#ec191b",
      //         shadowBlur: 0,
      //         label: null,
      //         labelLine: null,
      //         borderWidth: 1,
      //       },
      //       hoverAnimation: false,
      //
      //       data: [
      //         {
      //           value: 0,
      //           name: "0%",
      //           label: {
      //             position: "center",
      //             show: true,
      //             textStyle: {
      //               fontSize: "30",
      //               fontWeight: "bold",
      //               color: "#ec191b",
      //             },
      //           },
      //         },
      //         {
      //           value: 100,
      //           name: "目标稼动率",
      //           itemStyle: {
      //             color: "#f4f4f7",
      //           },
      //           emphasis: {
      //             itemStyle: {
      //               color: "#f4f4f7",
      //             },
      //           },
      //         },
      //       ],
      //       label: {
      //         show: false,
      //       },
      //     },
      //     {
      //       name: "生产进度",
      //       type: "pie",
      //       startAngle: 180,
      //       center: ["70%", "44%"],
      //       clockWise: false,
      //       radius: [50, 56],
      //       itemStyle: {
      //         color: "#5bdb5b",
      //         shadowColor: "#5bdb5b",
      //         shadowBlur: 0,
      //         label: null,
      //         labelLine: null,
      //         borderWidth: 1,
      //       },
      //       hoverAnimation: false,
      //
      //       data: [
      //         {
      //           value: 0,
      //           name: "0%",
      //           label: {
      //             position: "center",
      //             show: true,
      //             textStyle: {
      //               fontSize: "30",
      //               fontWeight: "bold",
      //               color: "#5bdb5b",
      //             },
      //           },
      //         },
      //         {
      //           value: 100,
      //           name: "目标稼动率",
      //           itemStyle: {
      //             color: "#f4f4f7",
      //           },
      //           emphasis: {
      //             itemStyle: {
      //               color: "#f4f4f7",
      //             },
      //           },
      //         },
      //       ],
      //       label: {
      //         show: false,
      //       },
      //     },
      //   ],
      // },
      //
      // planInfo: {}, // 制令，零件，计划数量
      //
      // stopTime: 0, // 停机时间
      //
      // // 状态
      // option1:{
      //     legend:[
      //             {
      //         orient: 'vertical',
      //         x:'-6%',
      //         y:'15%',
      //         textStyle: {
      //             color: '#fft'
      //         },
      //         data: [],
      //     },{
      //         orient: 'vertical',
      //         x:'-6%',
      //         y:'23.5%',
      //         textStyle: {
      //             color: '#fft'
      //         },
      //         data: [],
      //     },{
      //         orient: 'vertical',
      //         x:'-6%',
      //         y:'31.5%',
      //         textStyle: {
      //             color: '#fft'
      //         },
      //         data: [],
      //     },{
      //         orient: 'vertical',
      //         x:'-6%',
      //         y:'39.5%',
      //         textStyle: {
      //             color: '#fft'
      //         },
      //         data: [],
      //     },{
      //         orient: 'vertical',
      //         x:'-6%',
      //         y:'47.5%',
      //         textStyle: {
      //             color: '#fft'
      //         },
      //         data: [],
      //     },{
      //         orient: 'vertical',
      //         x:'-6%',
      //         y:'55.5%',
      //         textStyle: {
      //             color: '#fft'
      //         },
      //         data: [],
      //     },{
      //         orient: 'vertical',
      //         x:'-6%',
      //         y:'63.5%',
      //         textStyle: {
      //             color: '#fft'
      //         },
      //         data: [],
      //     },{
      //         orient: 'vertical',
      //         x:'-6%',
      //         y:'71.5%',
      //         textStyle: {
      //             color: '#fft'
      //         },
      //         data: [],
      //     },{
      //         orient: 'vertical',
      //         x:'-6%',
      //         y:'79.5%',
      //         textStyle: {
      //             color: '#fft'
      //         },
      //         data: [],
      //     }],
      //     tooltip: {
      //         trigger: 'axis'
      //     },
      //     grid: {
      //         left: '13%',
      //         right: '4%',
      //         bottom: '3%',
      //         containLabel: true
      //     },
      //     xAxis: {
      //         type: 'category',
      //         data: [],
      //         axisLine: {
      //             show: true,
      //             lineStyle: {
      //                 color: 'white'
      //             }
      //         },
      //     },
      //     yAxis: {
      //         show: false,
      //         type: 'value',
      //         axisTick:{       //y轴刻度线
      //             show:false
      //         },
      //         splitLine: {     //网格线
      //             show: false
      //         },
      //     },
      //     series: []
      // },
      //
      // // 设置颜色
      // yAxis1: [
      //   {
      //     data: [
      //       "一拉拉伸机",
      //       "二拉拉伸机",
      //       "切边冲床",
      //       "翻边冲床",
      //       "卷边专机",
      //       "切片上料机",
      //       "1#机器人",
      //       "2#机器人",
      //       "3#机器人",
      //     ],
      //     axisLabel: {
      //       show: true,
      //       textStyle: {
      //         color: "white", //这里是改变字体颜色
      //         fontSize: 12,
      //       },
      //     },
      //   },
      // ],
      // xAxis: [
      //   {
      //     axisLabel: {
      //       show: true,
      //       textStyle: {
      //         color: "white", //这里是改变字体颜色
      //         fontSize: 12,
      //       },
      //     },
      //   },
      // ],
      // faultyAxis1: [
      //   {
      //     data: [
      //       "一拉拉伸机",
      //       "二拉拉伸机",
      //       "切边冲床",
      //       "翻边冲床",
      //       "卷边专机",
      //       "切片上料机",
      //       "1#机器人",
      //       "2#机器人",
      //       "3#机器人",
      //     ],
      //     axisLabel: {
      //       show: true,
      //       textStyle: {
      //         color: "white", //这里是改变字体颜色
      //         fontSize: 12,
      //       },
      //     },
      //   },
      // ],
      // faultyxAxis: {
      //   data: [
      //     "1秒",
      //     "2秒",
      //     "3秒",
      //     "4秒",
      //     "5秒",
      //     "6秒",
      //     "7秒",
      //     "8秒",
      //     "9秒",
      //     "10秒",
      //     "11秒",
      //     "12秒",
      //     "13秒",
      //     "14秒",
      //     "15秒",
      //     "16秒",
      //     "17秒",
      //     "18秒",
      //     "19秒",
      //     "20秒",
      //     "21秒",
      //     "22秒",
      //     "23秒",
      //     "24秒",
      //     "25秒",
      //     "26秒",
      //     "27秒",
      //     "28秒",
      //     "29秒",
      //     "30秒",
      //     "31秒",
      //     "32秒",
      //     "33秒",
      //     "34秒",
      //     "35秒",
      //     "36秒",
      //     "37秒",
      //     "38秒",
      //     "39秒",
      //     "40秒",
      //     "41秒",
      //     "42秒",
      //     "43秒",
      //     "44秒",
      //     "45秒",
      //     "46秒",
      //     "47秒",
      //     "48秒",
      //     "49秒",
      //     "50秒",
      //     "51秒",
      //     "52秒",
      //     "53秒",
      //     "54秒",
      //     "55秒",
      //     "56秒",
      //     "57秒",
      //     "58秒",
      //     "59秒",
      //     "60秒",
      //   ],
      //   axisLabel: {
      //     show: true,
      //     textStyle: {
      //       color: "white", //这里是改变字体颜色
      //       fontSize: 12,
      //     },
      //   },
      // },
      //
      // A_Feed: [],
      // A_Pull_1: [],
      // A_Pull_2: [],
      // A_Punch_1: [],
      // A_Punch_2: [],
      // A_Expert: [],
      // A_robot_1: [],
      // A_robot_2: [],
      // A_robot_3: [],
      // chartData: {
      //   columns: ["Time", "Robot", "Status"],
      //   rows: [
      //     {
      //         Time: `1秒`,
      //         Robot: '一拉拉伸机',
      //         Status: 0,
      //     },{
      //         Time: `2秒`,
      //         Robot: '二拉拉伸机',
      //         Status: 0,
      //     },{
      //         Time: `1秒`,
      //         Robot: '切边冲床',
      //         Status: 0,
      //     },{
      //         Time: `55秒`,
      //         Robot: '切边冲床',
      //         Status: 0,
      //     },{
      //         Time: `56秒`,
      //         Robot: '切边冲床',
      //         Status: 1,
      //     },{
      //         Time: `57秒`,
      //         Robot: '切边冲床',
      //         Status: 0,
      //     },{
      //         Time: `58秒`,
      //         Robot: '切边冲床',
      //         Status: 1,
      //     },{
      //         Time: `59秒`,
      //         Robot: '切边冲床',
      //         Status: 0,
      //     },{
      //         Time: `2秒`,
      //         Robot: '一拉拉伸机',
      //         Status: 1,
      //     },{
      //         Time: `60秒`,
      //         Robot: '切边冲床',
      //         Status: 1,
      //     },{
      //         Time: `2秒`,
      //         Robot: '一拉拉伸机',
      //         Status: 1,
      //     },{
      //         Time: `2秒`,
      //         Robot: '一拉拉伸机',
      //         Status: 1,
      //     },{
      //         Time: `2秒`,
      //         Robot: '一拉拉伸机',
      //         Status: 1,
      //     },
      // ],
      // },
      // faultData: {
      //   columns: ["robot", "error"],
      //   rows: [
      //     { robot: "切边冲床", error: 0, IsActive: false },
      //     { robot: "翻边冲床", error: 0, IsActive: false },
      //     { robot: "卷边专机", error: 0, IsActive: false },
      //     { robot: "切片上料机", error: 0, IsActive: false },
      //     { robot: "1#机器人", error: 0, IsActive: false },
      //     { robot: "2#机器人", error: 0, IsActive: false },
      //     { robot: "3#机器人", error: 0, IsActive: false },
      //   ],
      // },
      // planData: {
      //   columns: ["type", "a", "b", "value"],
      //   rows: [{ type: "进度", value: 80, a: 10, b: 3 }],
      // },
    };
  },
  created() {
    // 获取制令，零件，计划数量等
    this.getForm(); // 请求当前生产数据


    this.AllotDevices();  // 设备对象模型分配

    clearInterval(this.Timer); // 清除定时器
    this.Timer = setInterval(()=>{
      this.PlansShow().then((res)=>{
      // console.log(res)
      if(res.meta.status === 200){
        res.data.map((e, i)=>{
          this.statementB.unshift({
            state:e.status, // 计划生产状态
            date:e.start, // 计划生产日期
            odd:e.numbers, // 计划生产制令
            name:e.model, // 计划生产零件名称
            yield:e.output, // 计划生产产量
          });
        })
      }
    })
    }, 1000*60*10)


    // this.client = this.$mqtt.connect("ws:192.168.3.62:9001");
    this.client = this.$mqtt.connect("ws:139.155.149.87:9001");
    this.client.on("connect", (e) => {
      this.client.subscribe("019PLC", (err) => {
        if (!err) {
          console.log("链接成功");
        }
      });
    });
    //  接收
    this.client.on("message", (topic, message) => {
      let mqtts = JSON.parse(message);
      if (message != "") {
        this.MqttData(mqtts.datas);
      }
    });





    // this.deviseState(); // 视图初始化属性

    // this.client = this.$mqtt.connect("ws:192.168.3.62:9001");
    // this.client = this.$mqtt.connect("ws:139.155.149.87:9001");
    // this.client.on("connect", (e) => {
    //   this.client.subscribe("019PLC", (err) => {
    //     if (!err) {
    //       console.log("链接成功");
    //     }
    //   });
    // });
    // //  接收
    // this.client.on("message", (topic, message) => {
    //   let mqtts = JSON.parse(message);
    //   if (message != "") {
    //     this.MqttData(mqtts.datas);
    //     // this.Mqtts(mqtts.datas);
    //   }
    // });
    // 测试数据
    // this.createdata(); // 测试数据
  },
  computed:{
    ...mapState(['initInfo', 'driveObj', 'productInfoB', 'ToRender']),
  },
  mounted() {

    // this.StateEcharts();
    // this.EfficencyEcharts();


    // window.onresize = () => {
      // this.efficency.resize();
      // this.echarts1.resize();
    // };
  },
  methods: {
    ...mapMutations(["MutationsState"]),

    //  处理mqtt传过来的数据
    MqttData(mqtts) {
      let Point = {};
      for (let k of mqtts) {
        // this.Point[k.nm] = k.v;
        Point[k.nm] = k.v;
      }
      // console.log(Point)
      this.MutationsState({value: Point, axios: this.axios});
    },

    // json对象转换
    toJsonObj(obj){
      return JSON.parse(JSON.stringify(obj));
    },

    // 设备对象模型分配
    AllotDevices(){
      this.initInfo.line = 'B' // B线
      if(!localStorage.getItem('initTimeB')){
        localStorage.setItem('initTimeB', new Date().getTime());
        this.initInfo.initTime = new Date().getTime();
      }else{
        this.initInfo.initTime = parseInt(localStorage.getItem('initTimeB'));
      }
      if(!this.initInfo.initTime){this.initInfo.initTime = new Date().getTime();}



    },

    deviseState(){ // 视图初始化属性
      this.devicelist.map((e,i)=>{
        this.option1.legend[i].data.push(e);
        this.option1.series.push({
          name: e,
          type: 'line',
          step: 'start',
          data: [],
        });
      });
      for(let i=1;i<61;i++){
        this.option1.xAxis.data.push(`${i}`);
      }
      this.devicelist.map((e,i) => {
        for(let j=0;j<60;j++){
          this.option1.series[i].data.push((i+1)*10);
        }
      })
    },



    // async getPlan() {
    //   let { data: res } = await this.axios.get("/plan");
    //   return res
    // },
    async PlansShow() {
      let { data: res } = await this.axios.get("/daysplanb");
      return res
    },

    async getForm(){
      let { data: res} = await this.axios.get("/form");
      if(res.status === 200){
          this.form.code = res.B.number;
          this.form.name = res.B.model;
          this.form.product = res.B.output;
          this.driveObj.driveB.productInfo.number = res.B.number;
          this.driveObj.driveB.productInfo.model = res.B.model;
          this.driveObj.driveB.productInfo.output = res.B.output;
      }
    },

    editConfig(){
      if(!this.form.name || !this.form.code || !this.form.product){
        this.$message({
          type: 'warning',
          message: '修改信息不能为空!!!'
        });
      }else{
        this.innerVisible = true;
      }
    },

    submit(){
      let that = this;
      if(!this.form.password){
        this.$message({
          type: 'error',
          message: '密码错误!!!'
        });
      }else{
        this.axios({
          method: "put",
          url: "/form",
          data: {
            line: 'B',
            number: that.form.code,
            model: that.form.name,
            output: that.form.product,
            password: that.form.password,
          }
        }).then((res)=>{
          // console.log(res)
          if(res.status === 200){
            that.$message({
              type: 'success',
              message: '修改成功!!!'
            });
            that.innerVisible = false;
            that.outerVisible = false;
            that.driveObj.driveB.productInfo.number = this.form.code;
            that.driveObj.driveB.productInfo.model = this.form.name;
            that.driveObj.driveB.productInfo.output = this.form.product;
          }else{
            this.$message({
              type: 'warning',
              message: '修改无效!!!注意输入密码是否正确.',
            })
          }
        }).catch((err)=>{
          this.$message({
            type: 'error',
            message: '请求异常!!!'
          })
        })
      }
    },

    //设置表格行的样式
    tableRowStyle({ row, column, rowIndex, columnIndex }) {
      return "padding: 10px;text-align:center;font-size:.10rem ;background-color:#11559c;color:#fff";
    },
    //设置表头行的样式
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return "background-color:#22a6f1;color:#fff;font-wight:500;font-size:.10rem;text-align:center;padding: 10px;";
    },

    async fullScreen() {
      let el = document.documentElement;
      let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullscreen;
      if (typeof rfs != "undefined" && rfs) {
        await rfs.call(el);
      }
      return;
    },

    exitScreen() {
      let el = document;
      let cfs =
        el.cancelFullScreen ||
        el.webkitCancelFullScreen ||
        el.mozCancelFullScreen ||
        el.exitFullScreen;
      //typeof cfs != "undefined" && cfs
      if (cfs) {
        cfs.call(el);
      } else if (typeof window.ActiveXObject !== "undefined") {
        //for IE，这里和fullScreen相同，模拟按下F11键退出全屏
        let wscript = new ActiveXObject("WScript.Shell");
        if (wscript != null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    LargeScreen() {
      // screenfull.toggle();
      if (this.isFullscreen == false) {
        this.$message.success("全屏");
        this.fullScreen();
      } else {
        this.$message.success("退出全屏");
        this.exitScreen();
      }
      this.isFullscreen = !this.isFullscreen;
    },
    checkFull() {
      let isFull =
        document.fullscreenEnabled ||
        window.fullScreen ||
        document.webkitIsFullScreen ||
        document.msFullscreenEnabled;
      //to fix : false || undefined == undefined
      if (isFull === undefined) {
        isFull = false;
      }
      return isFull;
    },
  },

  destroyed() {
    window.onresize = null;
  },
};
</script>

<style lang="less" scoped>
  .echarts1{
    width: 100%;
    height: 500px;
    /*border: 1px solid red;*/
    margin: 0 auto;
  }
  .tableSate{
    width: 100%;
    color: #FFFFFF;
    /*padding-top: 0.2rem;*/
  }
  .tableSate table {
    border: 1px solid #2c58a6;
  }

  .tableSate .td{
    text-align: center;
    border: 1px solid #2c58a6;
    box-sizing: border-box;
    height: 0.26rem;
    line-height: 0.26rem;
  }
  .tableSate .boxH{
    height: 1rem;
    line-height: 0.5rem;
  }
  .tableSate .th{
    height: 0.4rem;
    line-height: 0.4rem;
    font-weight: bold;
  }
  .red{
    color: red !important;
  }
  .green{
    color: green !important;
  }
  .yellow{
    color: yellow !important;
  }
  .white{
    color: white !important;
  }
  .orange{
    color: orange !important;
  }
@import "../../assets/css/monitoring.less";
</style>
